// vue
import { createApp } from 'vue/dist/vue.esm-bundler';
import axios from 'axios';

window.axios = axios;

import ModalEucPlus from './ModalEucPlus.vue';

const eucPlusModal = document.querySelector('#modalEucPlusComponent');

if ( eucPlusModal )
{
    createApp({
        components: {
            ModalEucPlus
        }
    }).mount('#modalEucPlusComponent');
}